import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PASSWORD_POLICY_REGEX } from '@/common/utils/regex';
import styles from './style.module.scss';

export type PasswordPolicyChecklistProps = {
  password: string;
  containerStyle?: React.CSSProperties;
};

export const PasswordPolicyChecklist = ({
  password,
  containerStyle,
}: PasswordPolicyChecklistProps) => {
  const { t: translate } = useTranslation();

  const status = useMemo(() => {
    return {
      length: PASSWORD_POLICY_REGEX.MIN_LENGTH.test(password),
      upper: PASSWORD_POLICY_REGEX.UPPERCASE.test(password),
      lower: PASSWORD_POLICY_REGEX.LOWERCASE.test(password),
      number: PASSWORD_POLICY_REGEX.NUMBER.test(password),
      special: PASSWORD_POLICY_REGEX.SPECIAL_CHAR.test(password),
    };
  }, [password]);

  return (
    <div className={styles.passwordPolicyContainer} style={containerStyle}>
      <p className={`${styles.item} ${status.length ? styles.valid : styles.invalid}`}>
        {status.length ? '✔' : '✖'} {translate('authentication.policy_length')} (14-16 chars)
      </p>
      <p className={`${styles.item} ${status.upper ? styles.valid : styles.invalid}`}>
        {status.upper ? '✔' : '✖'} {translate('authentication.policy_uppercase')}
      </p>
      <p className={`${styles.item} ${status.lower ? styles.valid : styles.invalid}`}>
        {status.lower ? '✔' : '✖'} {translate('authentication.policy_lowercase')}
      </p>
      <p className={`${styles.item} ${status.number ? styles.valid : styles.invalid}`}>
        {status.number ? '✔' : '✖'} {translate('authentication.policy_number')}
      </p>
      <p className={`${styles.item} ${status.special ? styles.valid : styles.invalid}`}>
        {status.special ? '✔' : '✖'} {translate('authentication.policy_special')} (!@$#%&)
      </p>
    </div>
  );
};

